exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-536fb602]{margin-top:35px}.handle[data-v-536fb602]{float:left}.close[data-v-536fb602],.handle[data-v-536fb602]{padding-top:8px;padding-bottom:8px}.close[data-v-536fb602]{float:right}input[data-v-536fb602]{display:inline-block;width:50%}.text[data-v-536fb602]{margin:20px}", ""]);

// exports
